module.exports = __webpack_public_path__ + "img/从毕加索.c959381a.png";